module.exports = __webpack_public_path__ + "img/driveline-page.5a3154fb.png";